import type { ProfileFieldConfig } from '../../domain/profile/profile-types';
import {
  compose,
  optionalOr,
  required,
  validEmail,
  validPhone,
} from '../../domain/profile/profile-validation';

export const ACCOUNT_SETUP_FIELDS: ProfileFieldConfig[] = [
  {
    id: 'mobilePhone',
    labelId: 'STR_MOBILE_PHONE_NUMBER',
    type: 'tel',
    optional: true,
    autoComplete: 'mobile tel',
    validate: optionalOr(validPhone),
  },
  {
    id: 'primaryPhone',
    labelId: 'STR_HOME_PHONE_NUMBER',
    type: 'tel',
    autoComplete: 'tel',
    validate: compose(required, validPhone),
  },
  {
    id: 'emailAddress',
    labelId: 'STR_EMAIL_ADDRESS',
    type: 'email',
    autoComplete: 'email',
    readOnly: true,
    validate: compose(required, validEmail),
  },
];
